import { useQuery } from "@tanstack/react-query";
import { retryLouiseQuery, useApiClient } from "@src/packages/api/louise-api";
import { throwApiError } from "@src/packages/api/api-error";
import type { CanonicalExperienceContext } from "../canonicalExperienceContext";

export type { CanonicalExperienceContext } from "../canonicalExperienceContext";

export function experienceContextQueryKey(patientId: string | null) {
  return ["experience-context", patientId] as const;
}

export function useExperienceContext() {
  const { client, patientId } = useApiClient();
  const queryKey = experienceContextQueryKey(patientId);

  return useQuery<CanonicalExperienceContext | null>({
    queryKey,
    queryFn: async () => {
      if (!patientId) return null;

      const { data, error, response } = await client.GET(
        "/patients/{patientId}/experience-context",
        {
          params: {
            path: { patientId },
          },
        },
      );

      if (error) {
        throwApiError(
          error,
          "Failed to load the experience context",
          "useExperienceContext",
          response.status,
        );
      }

      return data?.data ?? null;
    },
    enabled: !!patientId,
    retry: retryLouiseQuery,
  });
}
